import React, { useState } from 'react';
import './TooltipNew.scss'

const TooltipNew = ({ content, position = "top", children }) => {
  const [visible, setVisible] = useState(false);

  const showTooltip = () => setVisible(true);
  const hideTooltip = () => setVisible(false);

  return (
    <div 
      onMouseEnter={showTooltip} 
      onMouseLeave={hideTooltip}
      
    >
      {children}
      {visible && (
        <div className={`tooltip-box tooltip-${position}`}>
          {content}
        </div>
      )}
    </div>
  );
};

export default TooltipNew;
